import React, { useEffect, useState } from 'react'
import loader from "./loader.gif"

function LazyImage({ src, className, alt, onClick, style = {} }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  useEffect(() => {
    const img = document.createElement("img");
    img.src = src;

    img.addEventListener("load", () => {
      setImgLoaded(true)
    })

    img.addEventListener("error", () => {
      setImgLoaded(true)
    })
  }, [])

  return (
    <>
      {imgLoaded === true ? (
        <img style={style} src={src} className={className} alt={alt} onClick={() => onClick()} />
      ) : (
        <img style={style} src={loader} className={className} alt={alt} onClick={() => onClick()} />
      )}
    </>
  )
}

export default LazyImage